export default __webpack_public_path__ + "media/zurb/img/services/tools/sketching-screenshot2-38927cef82d99c889bba3c48f1a2ba7e.png";